import { render, staticRenderFns } from "./MemberBankAccountForm.vue?vue&type=template&id=a056f02c&"
import script from "./MemberBankAccountForm.vue?vue&type=script&lang=js&"
export * from "./MemberBankAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports